module.exports = __webpack_public_path__ + "assets/icon-theme-selected.dd1a3ca9.svg";